module.exports = __webpack_public_path__ + "static/media/IMG-17.84b03f93.jpg";